window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.modal-type-form_formframework').length) {
    import('./_user-data-show-modal-on-errors.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
